import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";
import { format } from 'date-fns';
import addDays from 'date-fns/addDays';

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsExcelService
    ,FvmsApiDtgReportCarService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
    ,dtgCarTypeList
} from "src/app/shared/vo";
import {
    FilterDist
    ,FilterSecToTime
} from "src/app/shared/filter";

@Component({
    selector: "report-car-month-main"
    ,templateUrl: './dtg.report.car.month.main.component.html'
    ,providers: [FilterDist,FilterSecToTime]
})
export class DtgReportCarMonthMainComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    listItem:any[] = [];
    pagingInfo:PagingInfo = new PagingInfo();
    excelPagingInfo:PagingInfo = new PagingInfo();
    dateTimeInfo:any;
    searchValue:string;
    searchDtgCarType:string = "";
    @Input() listType:DtgListType = DtgListType.list;
    selectedDate:any;
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;
    userGroupId:number;
    dtgTeamId:string = "";
    dtgCarType:string = "0";
    dtgCarTypeList = dtgCarTypeList;
    listYear:number[] = [];
    listMonth:number[] = [];
    selectedYear:number = 2020;
    selectedMonth:number = 1;
    maxDriveDtCnt:number = 0;

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsExcelService:FvmsExcelService
        ,private fvmsApiDtgReportCarService:FvmsApiDtgReportCarService
        ,private filterSecToTime:FilterSecToTime
        ,private filterDist:FilterDist
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.pagingInfo.pageSize = 15;
        this.excelPagingInfo.pageSize = 60*60*24;

        for(let a=2020;a<2100;a++){
            this.listYear.push(a);
        }
        for(let a=1;a<13;a++){
            this.listMonth.push(a);
        }

        let tmpDateInfo = this.fvmsCommonService.getDateInfo();
        if(tmpDateInfo && tmpDateInfo.fromDate){
            this.selectedYear = tmpDateInfo.fromDate.year;
            this.selectedMonth = tmpDateInfo.fromDate.month;
        }else{
            let today = new Date();
            this.selectedYear = today.getFullYear();
            this.selectedMonth = today.getMonth() + 1;
        }

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.pagingInfo.curPage = 1;
                this.clickSearch();
            });
     }

    ngOnInit() {
        // this.changeDate();
        // this.reloadListItem();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    getSearchInfo(){
        let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,1,0,0,0,0);
        let dtTo = new Date(this.selectedYear,this.selectedMonth,1,0,0,0,0);
        dtTo = addDays(dtTo,-1);
        let searchDateFrom = format(dtFrom,"yyyy-MM-dd 00:00:00");
        let searchDateTo = format(dtTo,"yyyy-MM-dd 23:59:59");
        let searchInfo = {
            companyId:this.companyInfo?.companyId || 0
            ,dtgTeamId:this.currentUserInfo?.teamId || ""
            ,dtgEid:this.companyInfo?.dtgEid || ""
            ,searchDateFrom:searchDateFrom
            ,searchDateTo:searchDateTo
            ,dtgCarType:this.searchDtgCarType
            ,searchValue:this.searchValue
            ,dtgGroupByRegDtYy:"Y"
            ,dtgGroupByRegDtMm:"Y"
            ,dtgGroupByUnitId:"Y"
        };
        return searchInfo;
    }

    reloadListItem(){
        this.fvmsCommonService.setIsLoading(true);
        this.maxDriveDtCnt = 0;
        this.fvmsApiDtgReportCarService.getListReportCar(this.getSearchInfo(),this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listItem = []
                    if(apiResponse.resultValue){
                        this.listItem = apiResponse.resultValue;
                        let size = this.listItem.length;
                        for(let a=0;a<size;a++){
                            let item = this.listItem[a];
                            if(item.dtgDriveDtCnt > this.maxDriveDtCnt){
                                this.maxDriveDtCnt = item.dtgDriveDtCnt;
                            }
                        }
                    }
                    this.pagingInfo = apiResponse.pagingInfo;
                }
                this.fvmsCommonService.setIsLoading(false);
            });
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.changeDate();
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.clickSearch();
    }

    clickSearch(){
        this.pagingInfo.curPage = 1;
        this.changeDate();
        this.reloadListItem();
    }

    changeCarType(e){
        this.clickSearch();
    }

    changeDate(){
        let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,1,0,0,0,0);
        let dtTo = new Date(this.selectedYear,this.selectedMonth,1,0,0,0,0);
        dtTo = addDays(dtTo,-1);
        let searchDateFrom = format(dtFrom,"yyyy-MM-dd 00:00:00");
        let searchDateTo = format(dtTo,"yyyy-MM-dd 23:59:59");
        this.selectedDate = {
            searchDateFrom:searchDateFrom
            ,searchDateTo:searchDateTo
        };
    }

    changeYear(e){
        this.changeDate();
        this.clickSearch();
    }

    changeMonth(e){
        this.changeDate();
        this.clickSearch();
    }

    // 리스트 운행율
    getDriveRatio(item){
        return Math.round((item.dtgDriveDtCnt / this.maxDriveDtCnt) * 100);
    }

    exportExcel(){
        this.fvmsCommonService.setIsLoading(true);
        this.fvmsApiDtgReportCarService.getListReportCar(this.getSearchInfo(),this.excelPagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.fvmsExcelService.excelDownload(this.convertExcelJson(apiResponse.resultValue),"car_driving_log");
                }
                this.fvmsCommonService.setIsLoading(false);
            });
    }

    convertExcelJson(dataList:any[]){
        let resultList = [];
        dataList.map((v) => {
            console.log(v);
            resultList.push({
                "차량번호":v.dtgCarNo
                ,"구분":v.dtgCarTypeNm
                ,"운행시간":this.filterSecToTime.transform(v.dtgRegDtDuration,"HH:mm:ss")
                ,"운행거리(km)":this.filterDist.transform(Number(v.dtgDistAccumul))
                ,"운행일":v.dtgDriveDtCnt
                ,"운행율(%)":v.dtgDriveRatio
                ,"트립수":v.dtgTripCnt
                ,"최근주행일시":v.dtgRegDtTo
                ,"주행운전자수":v.dtgDriverLcsNoCnt
                ,"연료소모량(L)":this.filterDist.transform(Number(v.dtgOilUseAccumul))
                ,"최근온도1(°C)":v.dtgTemper1
                ,"최근온도2(°C)":v.dtgTemper2
            })
        });
        return resultList;
    }
}